import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  Stack,
  IconButton,
} from "@mui/material";
import CustomIcon from "../customIcon";
import { useNavigate } from "react-router-dom";
import tokenTransferServices from "../../services/tokenTransferServices";
import { useSnackbar } from "notistack";
import WrongMnemonicErrorMsg from "./wrongMnemonicErrorMsg";
import AlgoErrorMsg from "./algoErrorMsg";
import SuccessOptedIn from "./successOptedIn";
import SucessFullTransfer from "./sucessFullTransfer";
import CloseIcon from "@mui/icons-material/Close";
const MnemonicUploadModal = ({ open, onClose, transactionId,closeAll,isOptin }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [mnemonicOption, setMnemonicOption] = useState("");
  const [mnemonicInput, setMnemonicInput] = useState("");
  const [mnemonicFile, setMnemonicFile] = useState(null);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [showOptinModal, setShowOptinModal] = useState(false);
  const [wrongMnemonicError, setWrongMnemonicError] = useState(false);
  const [algoErrorMsg,setAlgoErrorMsg]=useState(false)
  const [successModal,setSuccessModal]=useState(false)
  const [sucessFullTransferModal,setSucessFullTransferModal]=useState(false)
  //   const [setShowMnemonicModal, setShowMnemonicModal] = useState(false);

  const handleMnemonicFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setMnemonicFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setMnemonicInput(e.target.result);
      };
      reader.readAsText(file);
    }
  };

  const handleFinalSubmit = async () => {
    let data = {
      status:isOptin ? "OPTIN_COMPLETED" : "COMPLETED",
      transactionId: transactionId,
      isOptin: isOptin||false,
    };
    if (mnemonicOption === "file") {
      data.fileContent = mnemonicInput;
    } else if (mnemonicOption === "manual") {
      data.mnemonic = mnemonicInput;
    }

    try {
      const res = await tokenTransferServices.getOptinTransactions(data);
      if (res && res.success) {
        if (res?.isWrongEncryptedFile) setWrongMnemonicError(true);
        else if(res?.isOptin) setSuccessModal(true);
        else {
          setSucessFullTransferModal(true);
          enqueueSnackbar(res?.message || "Success", { variant: "success" });
        }
      } else {
        setAlgoErrorMsg(true)
        enqueueSnackbar(res?.message || "Something went wrong", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar(error?.message || "Something went wrong", {
        variant: "error",
      });
    }
  };

  const handleClose = () => {
    setMnemonicOption("");
    setMnemonicInput("");
    setMnemonicFile(null);
    onClose();
  };

  // Validate that mnemonic phrase contains exactly 25 words
  const isValidMnemonic = () => {
    if (!mnemonicInput) return false;
    const words = mnemonicInput.trim().split(/\s+/).filter(word => word.length > 0);
    return words.length === 25;
  };

  return (
    <Dialog open={open} onClose={() => onClose()}  maxWidth="sm" fullWidth>
      <WrongMnemonicErrorMsg
        open={wrongMnemonicError}
        handleClose={() => {
          setWrongMnemonicError(false);
        }}
      />
       <SuccessOptedIn open={successModal} handleClose={()=>{setSuccessModal(false); handleClose();closeAll()}}/>
       <SucessFullTransfer open={sucessFullTransferModal} handleClose={()=>{setSucessFullTransferModal(false); handleClose();closeAll()}}/>
       <AlgoErrorMsg open={algoErrorMsg} handleClose={()=>{setAlgoErrorMsg(false)}} /> 
        
      <Box
       sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: "16px", // so close button is not touching the edge
        }}
      >
      <DialogTitle sx={{ fontWeight: 600, fontSize: {xs:16,sm:18,md:20,lg:22,xl:24} }}>
        Verify Mnemonic Phrases
      </DialogTitle>
      <IconButton onClick={handleClose}>
        <CloseIcon />
      </IconButton>
      </Box>  
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Please provide your mnemonic phrase to authorize this token
            transfer.
          </Typography>

          {!mnemonicOption && (
            <Stack spacing={2}>
              <Typography variant="subtitle2" fontWeight={600}>
                Choose an option:
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<CustomIcon name="file-document" />}
                  onClick={() => setMnemonicOption("manual")}
                  sx={{ py: 2 }}
                >
                  Enter Manually
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<CustomIcon name="file" />}
                  onClick={() => setMnemonicOption("file")}
                  sx={{ py: 2 }}
                >
                  Upload File
                </Button>
              </Stack>
            </Stack>
          )}

          {mnemonicOption === "manual" && (
            <Stack spacing={2}>
              <Button
                size="small"
                onClick={() => {
                  setMnemonicOption("");
                  setMnemonicInput("");
                }}
                sx={{ alignSelf: "flex-start" }}
              >
                ← Back to options
              </Button>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Mnemonic Phrase"
                placeholder="Enter your 25-word mnemonic phrase"
                value={mnemonicInput}
                onChange={(e) => setMnemonicInput(e.target.value)}
                helperText={
                  mnemonicInput
                    ? (() => {
                        const wordCount = mnemonicInput.trim().split(/\s+/).filter(word => word.length > 0).length;
                        if (wordCount === 25) {
                          return "✓ Valid: 25 words entered";
                        } else {
                          return `Enter exactly 25 words (currently: ${wordCount} ${wordCount === 1 ? 'word' : 'words'})`;
                        }
                      })()
                    : "Enter your recovery phrase with words separated by spaces"
                }
                error={mnemonicInput && !isValidMnemonic()}
              />
            </Stack>
          )}

          {mnemonicOption === "file" && (
            <Stack spacing={2}>
              <Button
                size="small"
                onClick={() => {
                  setMnemonicOption("");
                  setMnemonicFile(null);
                  setMnemonicInput("");
                }}
                sx={{ alignSelf: "flex-start" }}
              >
                ← Back to options
              </Button>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{ py: 3 }}
              >
                <Stack alignItems="center" spacing={1} >
                  <CustomIcon name="file" sx={{ fontSize: 40 }} />
                  <Typography variant="body2" textAlign="center" sx={{wordBreak:"break-all"}} >
                    {mnemonicFile
                      ? mnemonicFile.name
                      : "Click to Upload Mnemonic File"}
                  </Typography>
                </Stack>
                <input
                  type="file"
                  hidden
                  accept=".txt"
                  onChange={handleMnemonicFileUpload}
                />
              </Button>
              {mnemonicInput && (
                <Typography variant="caption" color="success.main">
                  ✓ File uploaded successfully
                </Typography>
              )}
            </Stack>
          )}
          {mnemonicInput && !isOptin && (
            <Typography variant="caption" color="text.secondary">
              Note: Once you click on "Confirm Transfer", Then the Token will be transferred to the recipient DLT Account.
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        {/* <Button
          onClick={() => {
            onClose();
            setShowSummaryModal(true);
          }}
          variant="outlined"
        >
          Back
        </Button> */}
        <Button
          onClick={handleFinalSubmit}
          variant="contained"
          disabled={mnemonicInput=="" || (mnemonicOption==="manual" && !isValidMnemonic()) || (mnemonicOption==="file" && !mnemonicFile)}
        >
          Confirm Transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MnemonicUploadModal;
